<template>
  <transition
    name="custom-classes-transition"
    enter-active-class="animated fadeIn faster"
    leave-active-class="animated fadeOut faster"
  >
    <div id="note-modal" class="modal is-active" v-if="isVisible">
      <div class="modal-background" @click="close"></div>

      <div class="modal-content card">
        <div class="card-content">
          <h2 class="title">Add Note to {{ selectedCount }} Song(s)</h2>
          <form class="form m-t-20" @submit.prevent="saveNote">
            <div class="field">
              <label class="label">Note Content</label>
              <div class="control">
                <textarea
                  v-model="noteContent"
                  class="textarea"
                  placeholder="Enter your note here..."
                  rows="4"
                  :disabled="isLoading"
                ></textarea>
              </div>
            </div>

            <progress
              v-if="isLoading"
              class="progress is-small is-primary"
              max="100"
            ></progress>

            <div class="level is-mobile m-t-30">
              <div class="level-left">
                <div class="level-item">
                  <button
                    type="submit"
                    class="button is-primary"
                    :disabled="!noteContent.trim() || isLoading"
                  >
                    {{ isLoading ? 'Saving...' : 'Save Note' }}
                  </button>
                </div>
                <div class="level-item">
                  <button
                    type="button"
                    class="button is-primary is-inverted"
                    @click="close"
                    :disabled="isLoading"
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
        <button class="modal-close is-large" @click="close" :disabled="isLoading"></button>
      </div>
    </div>
  </transition>
</template>

<script>
import NotesApi from '@/services/api/Notes'

export default {
  name: 'NoteModal',

  props: {
    isVisible: {
      type: Boolean,
      default: false
    },
    selectedSongs: {
      type: Array,
      default: () => []
    },
    selectedCount: {
      type: Number,
      default: 0
    }
  },

  data() {
    return {
      noteContent: '',
      isLoading: false
    }
  },

  watch: {
    isVisible(newValue) {
      if (newValue) {
        this.noteContent = ''
        this.isLoading = false
      }
    }
  },

  methods: {
    close() {
      if (!this.isLoading) {
        this.$emit('close')
      }
    },

    async saveNote() {
      if (!this.noteContent.trim()) {
        return
      }
      this.isLoading = true
      try {
        const songIds = this.selectedSongs.map(song => song.id)
        await NotesApi.storeNotes('song', songIds, this.noteContent.trim())
        this.$store.commit('alert', `Note added to ${songIds.length} song(s) successfully.`)
        this.close()
        this.$emit('notes-saved')
      } catch (err) {
        console.error('Error saving notes:', err)
        if (err.response) {
          this.$store.commit('error', err.response.data.message || 'Failed to save notes.')
        } else {
          this.$store.commit('error', 'Failed to save notes. Please try again.')
        }
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>
